import QuranScheduleDateModel from '../Apis/QuranScheduleDate'
import Controller from './Controller'

export default class QuranScheduleDateController extends Controller {
  constructor() {
    super(new QuranScheduleDateModel())
  }

  async assignTeacherDate(id, params) {
    const res = await this.model.assignTeacherDate(id, params);
    return this.Poup(res);
  }
  async getTeacherSchedule(id,params) {
    const res = await this.model.getTeacherSchedule(id, params);

    return res;
  }
  async getTeacherSchedules(params) {
    const res = await this.model.getTeacherSchedules(params);

    return res;
  }
}
